import React from 'react';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import ExportMenu from '../../components/ExportMenu';

const SettingsDropdown = ({
    isLocked,
    allActions,
    updateState,
    doCollapse,
    handleHistroy,
    printIt,
    download,
    showFaxModal,
    Update_fax_details,
    serviceType,
    selectedDocId,
    set_opendeletepopup,
    sendDraft,
    count,
    user_permission,
    entering,
}) => {
    return (
        <div className='icon_fun' style={{ display: 'inline-block' }}>
            {isLocked === true ? (
                <span className='lock_drop' style={{ cursor: 'not-allowed' }}>
                    <i className='fa fa-ellipsis-v' aria-hidden='true' />
                </span>
            ) : (
                <span>
                    <Dropdown
                        className='bulk-print-opt dropDown-svg'
                        style={{}}
                    >
                        <OverlayTrigger
                            placement='top'
                            onEntering={entering}
                            overlay={
                                <Tooltip
                                    id='tooltip'
                                    style={{
                                        backgroundColor: 'rgb(0, 35, 58)',
                                        color: 'white',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: 'rgb(0, 35, 58)',
                                            color: 'white',
                                        }}
                                    >
                                        Settings
                                    </div>
                                </Tooltip>
                            }
                        >
                            <Dropdown.Toggle
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                }}
                                variant='success'
                                id='dropdown-basic'
                                title='Settings'
                            >
                                <i
                                    className='fa fa-ellipsis-v'
                                    aria-hidden='true'
                                />
                            </Dropdown.Toggle>
                        </OverlayTrigger>

                        <Dropdown.Menu>
                            <ExportMenu
                                permission={user_permission}
                                callingFrom='smallView'
                                count={count}
                                doCollapse={() => doCollapse()}
                                updateState={(state) => {
                                    updateState({
                                        ...state,
                                    });
                                }}
                            />
                            <Dropdown.Item
                                title='View History'
                                onClick={() => handleHistroy()}
                            >
                                <span className='delivery-details'>
                                    <i className='fa fa-history' />
                                    View History
                                </span>
                            </Dropdown.Item>

                            {allActions.fax_now ? (
                                <Dropdown.Item
                                    title='Fax Now'
                                    onClick={() => showFaxModal()}
                                >
                                    <i className='fas fa-fax' />
                                    Send To Fax
                                </Dropdown.Item>
                            ) : null}

                            {allActions.update_fax_details ? (
                                <Dropdown.Item
                                    title='Update Fax Details'
                                    onClick={() => Update_fax_details()}
                                >
                                    <span className='delivery-details'>
                                        <svg
                                            className='icon-fill'
                                            width='39'
                                            height='34'
                                            viewBox='0 0 39 34'
                                            xmlns='http://www.w3.org/2000/svg'
                                        >
                                            <path d='M33.7879 11.6753C34.4225 10.9737 34.4225 9.82878 33.7879 9.16402L31.7838 6.94815C31.1826 6.24645 30.1471 6.24645 29.5125 6.94815L27.9761 8.64698C27.8425 8.79471 27.8425 9.09016 27.9761 9.27481L31.6836 13.3742C31.8506 13.5219 32.1178 13.5219 32.2514 13.3742L33.7879 11.6753ZM26.6734 10.0873L17.8889 19.8002L17.1874 24.2689C17.0872 24.8967 17.5548 25.4138 18.1227 25.303L22.1642 24.5274L30.9488 14.8145C31.1158 14.6668 31.1158 14.3713 30.9488 14.1867L27.2412 10.0873C27.0742 9.93958 26.807 9.93958 26.6734 10.0873ZM20.1267 22.053H21.73V23.4195L19.5589 23.8257L18.5235 22.6809L18.8909 20.2803H20.1267V22.053Z' />
                                            <path d='M5.87503 6.18655H7.16802C7.85493 6.18655 8.46102 6.82318 8.46102 7.54471V21.1263C8.46102 21.8903 7.85493 22.4845 7.16802 22.4845H5.87503C5.14772 22.4845 4.58203 21.8903 4.58203 21.1263V7.54471C4.58203 6.82318 5.14772 6.18655 5.87503 6.18655ZM23.977 4.06442V7.54471C24.6639 7.54471 25.27 8.18134 25.27 8.90287V10.2715L17.0473 19.3631L16.5574 22.4845H11.047C10.3197 22.4845 9.75402 21.8903 9.75402 21.1263V2.11207C9.75402 1.39054 10.3197 0.753906 11.047 0.753906H20.8253C21.1889 0.753906 21.5122 0.923676 21.7546 1.17833L23.5729 3.08824C23.8153 3.3429 23.977 3.68244 23.977 4.06442ZM25.27 21.0977L24.0163 22.4838C24.0032 22.4843 23.9901 22.4845 23.977 22.4845H21.731V22.0561H20.1277V20.2834H18.8919L18.555 22.4845H17.469L17.8899 19.8033L18.805 18.7915V19.0891C18.805 19.4711 19.0878 19.7681 19.4515 19.7681H20.7445C21.0677 19.7681 21.391 19.4711 21.391 19.0891V17.7309C21.391 17.3914 21.0677 17.0518 20.7445 17.0518H20.3784L25.27 11.6433V21.0977ZM15.5725 19.7681C15.8957 19.7681 16.219 19.4711 16.219 19.0891V17.7309C16.219 17.3914 15.8957 17.0518 15.5725 17.0518H14.2795C13.9158 17.0518 13.633 17.3914 13.633 17.7309V19.0891C13.633 19.4711 13.9158 19.7681 14.2795 19.7681H15.5725ZM15.5725 14.3355C15.8957 14.3355 16.219 14.0384 16.219 13.6564V12.2983C16.219 11.9587 15.8957 11.6192 15.5725 11.6192H14.2795C13.9158 11.6192 13.633 11.9587 13.633 12.2983V13.6564C13.633 14.0384 13.9158 14.3355 14.2795 14.3355H15.5725ZM20.7445 14.3355C21.0677 14.3355 21.391 14.0384 21.391 13.6564V12.2983C21.391 11.9587 21.0677 11.6192 20.7445 11.6192H19.4515C19.0878 11.6192 18.805 11.9587 18.805 12.2983V13.6564C18.805 14.0384 19.0878 14.3355 19.4515 14.3355H20.7445ZM11.6935 8.90287H22.0375V4.82839H20.7445C20.3808 4.82839 20.098 4.53129 20.098 4.14931V2.79115H11.6935V8.90287Z' />
                                        </svg>
                                        Update Fax Details
                                    </span>
                                </Dropdown.Item>
                            ) : null}
                            <Dropdown.Item
                                title='Print'
                                className='print-dropdown'
                                onClick={() => printIt([selectedDocId])}
                            >
                                <span>
                                    {' '}
                                    <i
                                        className={
                                            allActions.hasOwnProperty(
                                                'print'
                                            ) && allActions.print.icon !== null
                                                ? allActions.print.icon
                                                : 'fas fa-print'
                                        }
                                        style={{
                                            color:
                                                allActions.hasOwnProperty(
                                                    'print'
                                                ) &&
                                                allActions.print.color !== null
                                                    ? allActions.print.color
                                                    : {},
                                        }}
                                    />
                                    Print{' '}
                                </span>
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => download()}
                                title='Download'
                            >
                                <span>
                                    <i
                                        className={
                                            allActions.hasOwnProperty(
                                                'download'
                                            ) &&
                                            allActions.download.icon !== null
                                                ? allActions.download.icon
                                                : 'fas fa-download'
                                        }
                                        style={{
                                            color:
                                                allActions.hasOwnProperty(
                                                    'download'
                                                ) &&
                                                allActions.download.color !==
                                                    null
                                                    ? allActions.download.color
                                                    : {},
                                        }}
                                    />
                                    Download
                                </span>
                            </Dropdown.Item>
                            {serviceType &&
                            user_permission?.processName !== 'Export' ? (
                                <Dropdown.Item
                                    onClick={() => {
                                        sendDraft();
                                    }}
                                    title='Send via email'
                                >
                                    <span>
                                        <i className='fa-solid fa-envelope' />
                                        Send via email
                                    </span>
                                </Dropdown.Item>
                            ) : null}
                            {user_permission?.show_delete ? (
                                <Dropdown.Item
                                    onClick={set_opendeletepopup}
                                    title='Delete'
                                >
                                    <span>
                                        <i
                                            className={
                                                allActions.hasOwnProperty(
                                                    'delete'
                                                ) &&
                                                allActions.delete.icon !== null
                                                    ? allActions.delete.icon
                                                    : 'fas fa-trash-alt'
                                            }
                                            style={{
                                                color:
                                                    allActions.hasOwnProperty(
                                                        'delete'
                                                    ) &&
                                                    allActions.delete.color !==
                                                        null
                                                        ? allActions.delete
                                                              .color
                                                        : '#007DBC',
                                            }}
                                        />
                                        Delete
                                    </span>
                                </Dropdown.Item>
                            ) : null}
                        </Dropdown.Menu>
                    </Dropdown>
                </span>
            )}
        </div>
    );
};

export default SettingsDropdown;
